export let mock_desktopmenu = {
};



// WEBPACK FOOTER //
// ./src/mocks/desktopmenu/index.ts